import { render, staticRenderFns } from "./SuggestedResourcesModal.vue?vue&type=template&id=eb2957a0&scoped=true"
import script from "./SuggestedResourcesModal.vue?vue&type=script&lang=ts"
export * from "./SuggestedResourcesModal.vue?vue&type=script&lang=ts"
import style0 from "./SuggestedResourcesModal.vue?vue&type=style&index=0&id=eb2957a0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2957a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb2957a0')) {
      api.createRecord('eb2957a0', component.options)
    } else {
      api.reload('eb2957a0', component.options)
    }
    module.hot.accept("./SuggestedResourcesModal.vue?vue&type=template&id=eb2957a0&scoped=true", function () {
      api.rerender('eb2957a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/requests/SuggestedResourcesModal.vue"
export default component.exports